/**
 * Sentry initialization for the WMS web app.
 *
 * No-op when VITE_SENTRY_DSN is unset — local dev without Sentry config
 * runs unchanged.
 */
import * as Sentry from '@sentry/react';

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;

export function initSentry() {
  if (!dsn) return;
  if (import.meta.env.DEV) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE as string | undefined,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Performance traces: 10% in prod, 100% elsewhere.
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    // Session replay: 10% of sessions, 100% of sessions with errors.
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    sendDefaultPii: false,
  });
}

export { Sentry };
